import { Component, EventEmitter, Input, OnInit, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidarCadastroRequest } from 'src/app/shared/models/validar-cadastro-request.model';
import { PasswordConfirmationErrorMatcher } from './password-confirmation-error-matcher.model';
import { CustomValidators } from 'src/app/perfil/alterar-senha-perfil-page/custom-validator';
import { Subject, Subscription, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgOtpInputComponent } from 'ng-otp-input';
import { Location } from '@angular/common';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Component({
  selector: 'app-confirmar-cadastro-form',
  templateUrl: './confirmar-cadastro-form.component.html',
  styleUrls: ['./confirmar-cadastro-form.component.scss']
})
export class ConfirmarCadastroFormComponent implements OnInit, OnChanges {

  validarCadastro: ValidarCadastroRequest = new ValidarCadastroRequest();
  confirmarSenha: string;
  form: FormGroup;
  matcher = new PasswordConfirmationErrorMatcher();
  showValidation = false;
  showNewPassword = false;
  showTokenResponseError: boolean
  habilitarBotaoEnviar: boolean


  timerSubscription: Subscription;
  stopTimer$ = new Subject();

  subscriptions = new Subscription();

  @Input()
  botaoConfirmacaoLabel = 'Confirmar Cadastro';

  @Input()
  loading = false;

  @Input()
  loadingSendToken = false;

  @Input()
  confirmTokenError = null;

  @Input()
  disableResend = false;

  @Output()
  confirmar: EventEmitter<ValidarCadastroRequest> = new EventEmitter();

  @Output()
  resendToken: EventEmitter<boolean> = new EventEmitter();
  
  @Output()
  voltar: EventEmitter<void> = new EventEmitter();

  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput: NgOtpInputComponent;

  showConfirmNewPassword: any;
  sendTokenResponseError;
  timerInProgress: boolean;
  secondTicks = 30;
  readonly timeToRetry = 30; // Segundos;

  constructor(
    private formBuilder: FormBuilder,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      token: ['', [Validators.required, Validators.minLength(6)]],
      senha: ['', Validators.compose([
        Validators.required,
        // 2. check whether the entered password has a number
        CustomValidators.patternValidator(/\d/, { hasNumber: true }),
        // 3. check whether the entered password has upper case letter
        CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        // 4. check whether the entered password has a lower-case letter
        CustomValidators.patternValidator(/[a-z]/, { hasSmallCase: true }),
        // 5. check whether the entered password has a special character
        CustomValidators.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, { hasSpecialCharacters: true }),
        Validators.minLength(8)
      ])],
      confirmarSenha: ['', [Validators.required]]
    }, { validator: this.checkPasswords });

    this.registerTimerSubscription()
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  checkPasswords(group: FormGroup): any {
    const { value: senha } = group.get('senha');
    const { value: confirmarSenha } = group.get('confirmarSenha');

    const isFieldValid = (confirmarSenha === senha) || group.get('confirmarSenha').hasError('required');

    return isFieldValid ? null : { passwordsDoNotMatch: true };
  }

  confirmarCadastro(e): void {
    e.preventDefault();
    const { confirmarSenha, ...confirmarCadastro } = this.form.value;
    this.confirmar.emit(confirmarCadastro);
  }

  getIconByErrorStatus(errorToTrack: string): { icon: string, color: string } {
    const iconsByStatus = {
      error: 'cancel',
      valid: 'check_circle',
      neutral: 'circle'
    };

    if (this.form.get('senha').touched && (this.form.get('senha').hasError('required') || this.form.get('senha').hasError(errorToTrack))) {
      return { icon: iconsByStatus.error, color: 'text-error' };
    }

    if (this.form.get('senha').dirty && !this.form.get('senha').hasError('required') && !this.form.get('senha').hasError(errorToTrack)) {
      return { icon: iconsByStatus.valid, color: 'text-valid' };
    }

    return { icon: iconsByStatus.neutral, color: 'text-neutral' };
  }

  onOtpInputChange(e: any) {
    this.form.get('token').setValue(e);
    if (this.confirmTokenError) {
      this.confirmTokenError = null;
    }
  }

  handleResendToken() {
    this.form.get('token').setValue('');
    this.ngOtpInput.setValue('');
    this.registerTimerSubscription();
    this.resendToken.emit(true);
  }

  registerTimerSubscription() {
    this.timerSubscription = timer(1000, 1000).pipe(takeUntil(this.stopTimer$)).subscribe((val) => {
      this.timerInProgress = true;
      this.secondTicks = this.timeToRetry - val;
      if (this.secondTicks < 0) {
        this.secondTicks = 30;
        this.timerInProgress = false;
        this.timerSubscription.unsubscribe();
      }
    });

    this.subscriptions.add(this.timerSubscription);
  }

  handleGoBack() {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'voltar'
    });
    this.voltar.emit();
  }

}
